<template>
  <FormContainer @submitForm="saveTemplate">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome del modello"
        v-model="template.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Ricavo stimato"
        v-model="template.ricavo"
        :errorMsg="errorHash['ricavo']"
        @input="removeError('ricavo')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Aliquota IVA"
        v-model.number="template.vat"
        :errorMsg="errorHash['vat']"
        @input="removeError('vat')"
      />
    </div>

    <FormInputProjectLibraryPersonnelCostsWidget
      class="mt-4"
      label="Costi del personale"
      v-model="template.personnelCosts"
      :costs="personnel"
    />

    <FormInputProjectLibraryCostsWidget
      class="mt-4"
      label="Costi"
      v-model="template.costs"
      :costs="libraryCosts"
    />

    <FormInputProjectLibraryImputedCostsWidget
      class="mt-4"
      label="Costi figurati"
      v-model="template.imputedCosts"
      :costs="libraryImputedCosts"
    />

    <div class="row">
      <FormInputTextareaWidget
        class="col-12"
        label="Note"
        v-model="template.notes"
        :errorMsg="errorHash['notes']"
        @input="removeError('notes')"
        not-required
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva modello di progetto
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-cost',
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormInputTextareaWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextareaWidget'),
    FormInputProjectLibraryCostsWidget: () => import('./Widgets/FormInputProjectLibraryCostsWidget'),
    FormInputProjectLibraryImputedCostsWidget: () => import('./Widgets/FormInputProjectLibraryImputedCostsWidget'),
    FormInputProjectLibraryPersonnelCostsWidget: () => import('./Widgets/FormInputProjectLibraryPersonnelCostsWidget'),
  },
  props: {
    template: {
      type: Object,
      default: () => ({
        name: null,
        ricavo: null,
        vat: null,
        costs: [],
        imputedCosts: [],
        personnelCosts: [],
        notes: null,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    libraryCosts: {
      type: Array,
      default: () => [],
    },
    libraryImputedCosts: {
      type: Array,
      default: () => [],
    },
    personnel: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.template.name) {
        this.addError('Il nome del modello è obbligatorio', 'name');
      }

      return !this.hasErrors;
    },
    saveTemplate () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.template);
    },
  },
};

</script>
